import { FC } from "react";
import { withProps } from "hoc-with-props";

import { Empty } from "../../../layout";
import { EmptyProps } from "../../../layout/Empty";
import { ReactComponent as Favourites } from "./assets/favourites.svg";

/**
 * Empty component for favourites
 */
export default withProps({
  illustration: <Favourites />
})(Empty) as FC<Omit<EmptyProps, "illustration">>;
